// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"6fd6bd0b","225":"7dbd1ae0","855":"4dda8661"}[chunkId] + ".chunk.css";
};